import {
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core'

export enum ModalStatus {
  Active,
  Hidden,
  Loading,
}

@Component({
  standalone: false,
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  @Input() status: ModalStatus = ModalStatus.Hidden

  @Input() entity: any
  @Input() title = 'Modal'

  @Input() showHeader = true
  @Input() showHeaderButtons = true
  @Input() hideClickOutside = true

  @Input() acceptButtonText = 'Save changes'
  @Input() loadingText = "It's loading"
  @Input() cancelButtonText = 'Cancel'

  @Output() onClickOutside = new EventEmitter<any>()
  @Output() onCancel = new EventEmitter<any>()
  @Output() onAccept = new EventEmitter<any>()
  @Output() onChangeStatus = new EventEmitter<any>()

  @Input() component: ComponentRef<any>
  @Input() loading = false

  @Input() acceptLoading = false
  @Input() acceptDisabled = false

  success: any
  error: any

  @ViewChild('content', { static: false }) content: ElementRef
  maxHeight: number

  @HostBinding('class.shown')
  get shown() {
    return this.status === ModalStatus.Active
  }

  @HostListener('click', ['$event.target'])
  onClick(target) {
    if (!this.hideClickOutside && target.className === 'shown') {
      this.onClickOutside.emit()
    }
  }

  get fullMessage() {
    return (
      (this.success && this.success.message) ||
      (this.error && this.error.message)
    )
  }

  get message() {
    return this.fullMessage
      .split('.')
      .filter((s) => s)
      .slice(-1)[0]
  }

  get firstPartMessage(): string {
    const splittedMessage = this.fullMessage.split('.').filter((s) => s)
    return splittedMessage.length === 2 ? splittedMessage[0] : ''
  }

  constructor(
    private renderer: Renderer2,
    private appRef: ApplicationRef,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {}

  show() {
    this.maxHeight =
      (document.documentElement.getBoundingClientRect().height - 32) * 0.75
    if (this.component instanceof ComponentRef) {
      this.appRef.attachView(this.component.hostView)
      this.content.nativeElement.appendChild(
        this.component.location.nativeElement,
      )
    }
    this.status = ModalStatus.Active
  }

  hide() {
    if (this.status === ModalStatus.Active) {
      if (this.component instanceof ComponentRef) {
        this.appRef.detachView(this.component.hostView)
      }
      this.status = ModalStatus.Hidden
      this.onAccept = new EventEmitter<any>()
    }
  }

  accept() {
    this.onAccept.emit({ entity: this.component.instance.entity })
  }
}
